/**
 * The types shown in the colour legend, in the order the panel lists them.
 */
export const TAG_TYPES = ['String', 'Photo', 'Number', 'Date', 'Boolean'];

/**
 * The types whose keys are addressed through an `.index` marker.
 */
export const ARRAY_TYPES = [
  'array-ids',
  'array-object',
  'array-strings',
  'array-array-object'
];
